/* Wheel Good Tees — ATC "select a size" gate (Horizon / BuildMyPOD).
 *
 * No size pre-selected. While no size is chosen the green Add-to-cart button stays
 * bright-but-slightly-dimmed and reads "SELECT A SIZE"; clicking it just shakes the size
 * pills. Once a size is chosen it becomes full-bright green "ADD TO CART" and works.
 *
 * BuildMyPOD's handleClick bails on `!form.checkValidity()` (that's what plays / skips the
 * fly-to-cart animation). Horizon renders the size radios OUTSIDE the <form>, so the form
 * can't "see" them. We add a tiny nameless required proxy input INSIDE the form, kept empty
 * until a size is chosen — so checkValidity() is false with no size and handleClick bails
 * (no animation, no add). The proxy has no name, so it's never submitted. Belt-and-braces,
 * we also intercept the click to shake + block, and swallow the native invalid bubble. */
(function () {
  var NEED = 'SELECT A SIZE', ADD = 'ADD TO CART';

  function isSizeGroup(g) {
    return g.getAttribute('data-is-size-option') === 'true' || /size/i.test(g.getAttribute('data-option-name') || '');
  }
  function sizeGroups(scope) { return Array.prototype.slice.call(scope.querySelectorAll('.variant-option')).filter(isSizeGroup); }
  function btn(scope) { return scope.querySelector('.add-to-cart-button, button[name="add"]'); }
  function theForm(scope) { return scope.querySelector('form[action*="/cart/add"]'); }
  function scopeFor(form) {
    var box = form.closest('dialog, .shopify-section');
    if (!box) return null;
    var hasSize = Array.prototype.some.call(box.querySelectorAll('.variant-option'), isSizeGroup);
    return (hasSize && btn(box)) ? box : null;
  }
  function sizeChosen(scope) {
    return sizeGroups(scope).every(function (g) {
      var r = g.querySelectorAll('input[type="radio"]');
      if (r.length) return Array.prototype.some.call(r, function (x) { return x.checked; });
      var s = g.querySelector('select');
      return s ? !!s.value : true;
    });
  }
  // Nameless required proxy inside the form -> drives checkValidity() (and thus handleClick).
  function ensureProxy(scope) {
    var form = theForm(scope);
    if (!form) return null;
    var p = form.querySelector('.wgt-size-proxy');
    if (!p) {
      p = document.createElement('input');
      p.type = 'text'; p.className = 'wgt-size-proxy'; p.required = true;
      p.tabIndex = -1; p.setAttribute('aria-hidden', 'true'); p.autocomplete = 'off';
      p.style.cssText = 'position:absolute!important;left:0;bottom:0;width:1px;height:1px;opacity:0;pointer-events:none;border:0;padding:0;margin:0';
      form.appendChild(p);
    }
    return p;
  }

  function applyState(scope) {
    var b = btn(scope);
    if (!b) return;
    var chosen = sizeChosen(scope);
    var proxy = ensureProxy(scope);
    if (proxy) { var want = chosen ? 'ok' : ''; if (proxy.value !== want) proxy.value = want; }
    if (b.disabled) b.disabled = false;
    if (b.hasAttribute('disabled')) b.removeAttribute('disabled');
    if (b.hasAttribute('aria-disabled')) b.removeAttribute('aria-disabled');
    if (b.classList.contains('wgt-no-size') === chosen) b.classList.toggle('wgt-no-size', !chosen);
    var label = chosen ? ADD : NEED;
    b.querySelectorAll('.add-to-cart-text__content').forEach(function (el) {
      if (el.textContent.trim() !== label) el.textContent = label;
    });
  }
  function shake(scope) {
    sizeGroups(scope).forEach(function (g) { g.classList.remove('wgt-shake'); void g.offsetWidth; g.classList.add('wgt-shake'); });
    (sizeGroups(scope)[0] || btn(scope)).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function initScope(scope) {
    if (scope.__wgtGate) return;
    scope.__wgtGate = true;
    applyState(scope);

    scope.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"], select')) {
        sizeGroups(scope).forEach(function (g) { g.classList.remove('wgt-shake'); });
        applyState(scope);
      }
    });
    // Horizon relabels/disables + morphs on variant updates — re-assert after it runs.
    document.addEventListener('variant:update', function () { setTimeout(function () { applyState(scope); }, 0); });

    // Primary: click with no size -> shake + block. (Animation is already skipped by checkValidity.)
    scope.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.add-to-cart-button, button[name="add"], .shopify-payment-button')) return;
      if (sizeChosen(scope)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      shake(scope);
    }, true);
    // Backstop: if a submit ever slips through, swallow the native bubble and shake instead.
    var form = theForm(scope);
    if (form) form.addEventListener('invalid', function (e) { e.preventDefault(); shake(scope); }, true);
  }

  function boot() {
    document.querySelectorAll('product-form-component form, form[action*="/cart/add"]').forEach(function (f) {
      var s = scopeFor(f); if (s) initScope(s);
    });
  }
  document.readyState !== 'loading' ? boot() : document.addEventListener('DOMContentLoaded', boot);

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType !== 1) continue;
        var forms = [];
        if (n.matches && n.matches('form[action*="/cart/add"]')) forms.push(n);
        if (n.querySelectorAll) forms = forms.concat(Array.prototype.slice.call(n.querySelectorAll('product-form-component form, form[action*="/cart/add"]')));
        forms.forEach(function (f) { var s = scopeFor(f); if (s) initScope(s); });
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
